var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.selectedTeam,"items":_vm.sortedTeams,"label":"Select Team","item-text":"fullName","item-value":"abbreviation","return-object":"","filled":""},on:{"change":_vm.selected}})
}
var staticRenderFns = []

export { render, staticRenderFns }